<template>
	<div id="pie_echarts">
		
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			date:[{
		         value: 335,
		         name: "Apple"
		       }, {
		         value: 310,
		         name: "Grapes"
		       }, {
		         value: 234,
		         name: "Pineapples"
		       }, {
		         value: 135,
		         name: "Oranges"
		       }, {
		         value: 1548,
		         name: "Bananas"
		       }]
		}
	  },
	  methods: {
	  fontSize(res,initWidth=1920){
					var nowClientWidth = document.documentElement.clientWidth;
					return res*(nowClientWidth/initWidth);
				},
	   echartsLine(){
		   var echarts = require('echarts');
		   let energyConsumption = echarts.init(document.getElementById('pie_echarts'));
		   energyConsumption.setOption({
		     legend: {
				 show:false
		     },
			 title:[
				 {
					 show:true,
					 text:'流量',
					 left: "14%",
					 top:'40%',
					 textStyle: {
						   fontSize: this.fontSize(18),
						   color:'#a2c8f5'
					 },
				 },
				 {
					 show:true,
					 text:'水位',
					 left: "47.5%",
					 top:'40%',
					 textStyle: {
					   fontSize: this.fontSize(18),
					   color:'#a2c8f5'
					 },
				 },
				 {
					 show:true,
					 text:'蒸发量',
					 left: "80%",
					 top:'40%',
					 textStyle: {
					   fontSize: this.fontSize(18),
					   color:'#a2c8f5'
					 },
				 },
				 {
					 show:true,
					 text:'降雨量',
					 left: "13%",
					 top:'90%',
					 textStyle: {
					   fontSize: this.fontSize(18),
					   color:'#a2c8f5'
					 },
				 },
				 {
					 show:true,
					 text:'流速',
					 left: "47.5%",
					 top:'90%',
					 textStyle: {
					   fontSize: this.fontSize(18),
					   color:'#a2c8f5'
					 },
				 },
				 {
					 show:true,
					 text:'土壤墒情',
					 left: "79%",
					 top:'90%',
					 textStyle: {
					   fontSize: this.fontSize(18),
					   color:'#a2c8f5'
					 },
				 }
			 ],
				
		     series: [{
		       type: "pie",
			   center: ["16.6%", "20%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   // color:['#4d5967','#0079ff'],
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#007aff'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
		       data:[
					 {value:200-100,
						itemStyle: {
							color: "#505a66"
					    },
					 },
					 {value:100,
						itemStyle: {
							color: "#007aff"
					    },
					 },]
		     },
			 {
			   type: "pie",
			   center: ["49.9%", "20%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   // color:['#4d5967','red'],
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#a5cfff'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
			   data:[
					 {value:200-168,
						itemStyle: {
							color: "#505a66"
						},
					 },
					 {value:168,
						itemStyle: {
							color: "#a5cfff"
						},
					 },]
			 },
			 {
			   type: "pie",
			   name:'Apple',
			   center: ["83.2%", "20%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#00f9ff'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
			  data:[
					 {value:200-120,
						itemStyle: {
							color: "#505a66"
						},
					 },
					 {value:120,
						itemStyle: {
							color: "#00f9ff"
						},
					 },]
			 },
			 {
			   type: "pie",
			   name:'Apple',
			   center: ["16.6%", "70%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#00f9ff'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
			   data:[
				 {value:200-100,
					itemStyle: {
						color: "#505a66"
					},
				 },
				 {value:100,
					itemStyle: {
						color: "#00f9ff"
					},
				 },]
			 },
			 {
			   type: "pie",
			   name:'Apple',
			   center: ["49.9%", "70%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#0379ff'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
			   data:[
				 {value:200-150,
					itemStyle: {
						color: "#505a66"
					},
				 },
				 {value:150,
					itemStyle: {
						color: "#0379ff"
					},
				 },]
			 },
			 {
			   type: "pie",
			   name:'Apple',
			   center: ["83.2%", "70%"],
			   radius: ["28%", "35%"],
			   clockwise: false,
			   label: {
			      show:true,
				  position:'center',
				  formatter:(e)=>{
					  if(e.color=='#ffc602'){
						  return `{num|${e.data.value}}`
					  }
				  },
				  rich:{
					 num:{
						 color:'#00ff7f',
						 fontSize:20
					 } 
				  }
			   },
			   emphasis: {
			         scale: false
			       },
			   labelLine: {
			         show: false
			       },
			   data:[
				 {value:200-140,
					itemStyle: {
						color: "#505a66"
					},
				 },
				 {value:140,
					itemStyle: {
						color: "#ffc602"
					},
				 },]
			 },
			 ]
		   })
			window.addEventListener("resize", () => {
			  energyConsumption.resize();
			});
			
			},

	  },
	  mounted() {
	     this.echartsLine();
		 window.addEventListener("resize", () => {
		    this.echartsLine();
		 });
	  }
	};
</script>

<style scoped="scoped">
	#pie_echarts{
		position: relative;
		width: 50%;
		height: 50%;
		background: #FFFFFF;
		position: fixed;
		top: 100px;
		margin-left: -25%;
		left:50%;
		box-sizing: border-box;
		padding: 15px 15px;
	}
</style>
